module.exports = __webpack_public_path__ + "img/2BE1E.864a42fd.svg";